import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from './AuthContext'
import type { Role } from '@/lib/types'

/** Shared sign-in preserves the requested location; claims still control workspace access. */
export function RequireRole({ role }: { role: Role }) {
  const { user, loading } = useAuth()
  const location = useLocation()
  if (loading) return <div className="page"><p className="muted">Loading…</p></div>
  if (!user) return <Navigate to="/login" state={{ from: location.pathname + location.search + location.hash }} replace />
  if (user.role !== role) {
    if (user.role === null) return <div className="page"><p className="error">Your account has no role yet. Contact an engineer.</p></div>
    return <Navigate to={user.role === 'sme' ? '/sme' : '/eng'} replace />
  }
  return <Outlet />
}
